import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { useState, useEffect, useRef } from "react";

export default function SearchBar({ onSearch, debounceMs = 500 }) {
  const [value, setValue] = useState("");
  const debounceTimer = useRef(null);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer.current) {
        clearTimeout(debounceTimer.current);
      }
    };
  }, []);

  function handleChange(e) {
    const newValue = e.target.value;
    setValue(newValue);

    // Clear previous timer
    if (debounceTimer.current) {
      clearTimeout(debounceTimer.current);
    }

    // Set new timer for debounced search
    debounceTimer.current = setTimeout(() => {
      onSearch?.(newValue);
    }, debounceMs);
  }

  return (
    <div
      className="
        flex items-center 
        w-full
        max-w-[420px]
        rounded-xl 
        px-4 py-3 
        shadow-sm
      "
      style={{
        backgroundColor: "#F7F9FA", // << EXACT Figma background
        border: "1px solid #D9D9D9",
      }}
    >
      <MagnifyingGlassIcon className="w-5 h-5 text-gray-500" />
      <input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Search experiences..."
        className="
          ml-3 
          w-full 
          focus:outline-none 
          text-gray-700 
          placeholder-gray-500
          bg-transparent
        "
      />
    </div>
  );
}
